const defRules = [
  {
    idx: 'default',
    reschedulable: 1,
    reschedule: {
      mode: 2,
      rule: {
        hour: 3
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 2,
      rules: [
        {
          hour: 72,
          is_deposit_percent: true,
          deposit_percent: 0
        },
        {
          hour: 3,
          is_deposit_percent: true,
          deposit_percent: 20
        },
        {
          hour: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'hotel',
    reschedulable: 0,
    reschedule: {
      mode: 2,
      rule: {
        hour: 3
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 3,
          is_deposit_percent: true,
          deposit_percent: 0
        },
        {
          day: 1,
          is_deposit_percent: true,
          deposit_percent: 50
        },
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'uncancel',
    reschedulable: 0,
    reschedule: {
      mode: 2,
      rule: {
        hour: 3
      }
    },
    coolingOff: 0,
    no_show_penalty: 0,
    cancelable: 0,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'ticket_10days',
    reschedulable: 0,
    reschedule: {
      mode: 2,
      rule: {
        hour: 3
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 10,
          is_deposit_percent: true,
          deposit_percent: 10
        },
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'ticket_20days',
    reschedulable: 0,
    reschedule: {
      mode: 2,
      rule: {
        hour: 3
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 20,
          is_deposit_percent: true,
          deposit_percent: 5
        },
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'camping',
    reschedulable: 1,
    reschedule: {
      mode: 0,
      rule: {
        day: 1
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 10,
          is_deposit_percent: true,
          deposit_percent: 0
        },
        {
          day: 7,
          is_deposit_percent: true,
          deposit_percent: 25
        },
        {
          day: 4,
          is_deposit_percent: true,
          deposit_percent: 30
        },
        {
          day: 2,
          is_deposit_percent: true,
          deposit_percent: 35
        },
        {
          day: 1,
          is_deposit_percent: true,
          deposit_percent: 40
        },
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'handcraft_escape_parent-child_normal',
    reschedulable: 1,
    reschedule: {
      mode: 0,
      rule: {
        day: 4
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 7,
          is_deposit_percent: true,
          deposit_percent: 0
        },
        {
          day: 4,
          is_deposit_percent: true,
          deposit_percent: 50
        },
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'parent-child_16days',
    reschedulable: 1,
    reschedule: {
      mode: 0,
      rule: {
        day: 8
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 16,
          is_deposit_percent: true,
          deposit_percent: 0
        },
        {
          day: 8,
          is_deposit_percent: true,
          deposit_percent: 50
        },
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'parent-child_31days',
    reschedulable: 1,
    reschedule: {
      mode: 0,
      rule: {
        day: 8
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 0,
      rules: [
        {
          day: 31,
          is_deposit_percent: true,
          deposit_percent: 10
        },
        {
          day: 16,
          is_deposit_percent: true,
          deposit_percent: 30
        },
        {
          day: 8,
          is_deposit_percent: true,
          deposit_percent: 50
        },
        {
          day: 0,
          is_deposit_percent: true,
          deposit_percent: 100
        }
      ]
    }
  },
  {
    idx: 'yc',
    reschedulable: 1,
    reschedule: {
      mode: 2,
      rule: {
        hour: 0
      }
    },
    coolingOff: 1,
    no_show_penalty: 0,
    cancelable: 1,
    cancel: {
      mode: 2,
      rules: [
        {
          hour: 0,
          is_deposit_percent: true,
          deposit_percent: 0
        }
      ]
    }
  }
]

export default {
  data () {
    return {
      defaultRules: defRules
    }
  },
  methods: {
    $_initDefRules () {
      let prefix = 'api.product.fields.cancel_rule.default.'
      for (let i = 0; i < this.defaultRules.length; ++i) {
        let idx = this.defaultRules[i].idx
        let name = prefix + idx + '.name'
        let rule = prefix + idx + '.cancel_rule'
        this.defaultRules[i].name = this.$t(name)
        if (this.$te(rule)) {
          this.defaultRules[i].cancel_rule = this.$t(rule)
          this.defaultRules[i].trans = [
            this.$t(rule, 'zh-TW'),
            this.$t(rule, 'en-US'),
            this.$t(rule, 'zh-CN'),
            this.$t(rule, 'ja'),
            this.$t(rule, 'ms-MY')
          ]
        }
      }
    },
    $_getDefaultRules () {
      this.$_initDefRules()

      return this.defaultRules
    }
  }
}
